'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { connect } from 'react-redux';
import makeLoadable from 'AdsUI/lib/makeLoadable';
import { EntityTypes } from 'AdsUI/lib/Constants';
import { getCampaignForCampaignDetails, getChildrenFromProps, getCampaignTableAdGroup, getEntityData, getCampaignRequestStatus, getChildrenRequestStatus, getCampaignAdGroupRequestStatus } from 'AdsUI/selectors/CampaignReportingSelectors';
import { getNetworkFromParams } from 'AdsUI/selectors/PropsSelectors';
import { getAdAccountFromParams } from 'AdsUI/selectors/AccountsSelectors';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import FailedEntityManagementPanel from 'AdsUI/components/campaign-reporting/FailedEntityManagementPanel';
const EntityManagementPanelContainerLoader = makeLoadable(() => import('./EntityManagementPanelContainer'));
const KeywordEditModalContainerLoader = makeLoadable(() => import('./KeywordEditModalContainer'));

const ChildrenManagementPanelContainer = ({
  campaign,
  campaignChildren,
  match: {
    params: {
      sequenceId,
      accountId,
      campaignId,
      entityId
    }
  },
  adGroup,
  adAccount,
  entityType,
  network,
  history,
  campaignRequestStatus,
  childRequestStatus,
  adGroupRequestStatus
}) => {
  const parentId = adGroup ? adGroup.entity.id : null;
  const onClose = useCallback(() => {
    const sequencePath = sequenceId ? `/sequences/${sequenceId}` : '';

    switch (entityType) {
      case EntityTypes.ADGROUP:
        {
          history.push(`${sequencePath}/accounts/${network.toLowerCase()}/${accountId}/campaigns/${campaignId}`);
          break;
        }

      case EntityTypes.AD:
        {
          history.push(`${sequencePath}/accounts/${network.toLowerCase()}/${accountId}/campaigns/${campaignId}/adgroups/${parentId}`);
          break;
        }

      case EntityTypes.KEYWORD:
        {
          history.push(`/accounts/${network.toLowerCase()}/${accountId}/campaigns/${campaignId}/adgroups/${parentId}/keywords`);
          break;
        }

      default:
        {
          throw new Error('Invalid entity type');
        }
    }
  }, [sequenceId, entityType, history, network, accountId, campaignId, parentId]);
  const loading = !(campaignRequestStatus.fetchedSuccessfully() && childRequestStatus.fetchedSuccessfully() && (entityType === EntityTypes.ADGROUP || adGroupRequestStatus.fetchedSuccessfully()));
  const failed = campaignRequestStatus.fetchFailed || childRequestStatus.fetchFailed || entityType === EntityTypes.ADGROUP && adGroupRequestStatus.fetchFailed;

  if (loading && !failed) {
    return /*#__PURE__*/_jsx(UILoadingOverlay, {});
  }

  if (failed) {
    return /*#__PURE__*/_jsx(FailedEntityManagementPanel, {
      entityType: entityType,
      network: network,
      onClose: onClose
    });
  }

  const child = campaignChildren.get(entityId.toString());
  const parent = entityType === EntityTypes.ADGROUP ? campaign.entity : adGroup.entity;

  if (entityType === EntityTypes.KEYWORD) {
    return /*#__PURE__*/_jsx(KeywordEditModalContainerLoader, {
      entity: child.entity,
      parent: parent,
      campaignEntity: campaign.entity,
      adAccount: adAccount,
      entityType: entityType,
      network: network,
      onClose: onClose
    });
  }

  return /*#__PURE__*/_jsx(EntityManagementPanelContainerLoader, {
    entity: child.entity,
    trackingRecord: child,
    campaignEntity: campaign.entity,
    parent: parent,
    adAccount: adAccount,
    entityType: entityType,
    network: network,
    onClose: onClose,
    onEditCampaign: () => {
      history.push(`/accounts/${network.toLowerCase()}/${accountId}/campaigns/${campaignId}/manage-campaign`);
    },
    onOpenAdGroupPanel: () => {
      history.push(`/accounts/${network.toLowerCase()}/${accountId}/campaigns/${campaignId}/adgroups/${parent.id}/manage`);
    }
  });
};

const mapStateToProps = (state, props) => {
  return Object.assign({
    campaign: getCampaignForCampaignDetails(state, props),
    campaignChildren: getChildrenFromProps(state, props),
    adGroup: getCampaignTableAdGroup(state, props),
    adAccount: getAdAccountFromParams(state, props)
  }, getEntityData(state, props), {
    network: getNetworkFromParams(state, props),
    campaignRequestStatus: getCampaignRequestStatus(state, props),
    childRequestStatus: getChildrenRequestStatus(state, props),
    adGroupRequestStatus: getCampaignAdGroupRequestStatus(state, props)
  });
};

export default connect(mapStateToProps)(ChildrenManagementPanelContainer);